module.exports = __webpack_public_path__ + "img/02j_marketing.b2a62c93.jpg";